import createGetFormSubmitErrors from './selectors/getFormSubmitErrors';
import plain from './structure/plain';
export default createGetFormSubmitErrors(plain);


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/redux-form/es/getFormSubmitErrors.js
// module id = P4J6
// module chunks = 1